<template>
    <div>
        <div class="columns">
            <div class="column is-6 is-offset-3">
                <category-form :create="true" @saved="editCategory"></category-form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {}
        },
        methods: {
            editCategory(category) {
                this.$router.push({name: 'category', params: {id: category.id}})
            }
        }
    };
</script>



// WEBPACK FOOTER //
// CategoryCreate.vue?01989244